import React from 'react';
import styled from 'styled-components';

import Header from './shared/header';
import Filter from './shared/filter';
import BlogCards from './shared/blogCards';

const Section = styled.section``;

const Content = ({
  activeCategory,
  categories,
  changeCategory,
  blogs,
  searchedValue,
  setSearchedValue,
}) => (
  <Section>
    <Header />
    <Filter
      activeCategory={activeCategory}
      categories={categories}
      changeCategory={changeCategory}
      setSearchedValue={setSearchedValue}
    />
    <BlogCards
      blogs={blogs}
      activeCategory={activeCategory}
      changeCategory={changeCategory}
      searchedValue={searchedValue}
    />
  </Section>
);

export default Content;
